import { memo, useCallback } from "react";
import { Athlete } from "types/athlete";
import Checkbox from "components/mui5/Checkbox";
import { useMultiSelectIds, useSetMultiSelect } from "providers/MultiSelectProvider";
import CheckBoxOutlined from "@mui/icons-material/CheckBoxOutlined";
import { useTranslation } from "react-i18next";
import AthleteHelpers from "helpers/AthleteHelpers";

interface AthleteTableRowCheckboxContainerProps {
  athlete: Athlete;
}

function AthleteTableRowCheckboxContainer(props: AthleteTableRowCheckboxContainerProps) {
  const { athlete } = props;

  const selectedIds = useMultiSelectIds();
  const setSelectedIds = useSetMultiSelect();
  const { t } = useTranslation();

  const toggleSelected = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      setSelectedIds({ [athlete.id]: !selectedIds.includes(athlete.id) });
    },
    [athlete.id, selectedIds, setSelectedIds]
  );

  const athleteFullName = AthleteHelpers.getFullName(athlete);

  return (
    <Checkbox
      checkedIcon={<CheckBoxOutlined />}
      slotProps={{
        input: {
          "aria-label": t("athlete.select_athlete_name_aria_label", { name: athleteFullName }),
        },
      }}
      checked={selectedIds.includes(athlete.id)}
      onClick={toggleSelected}
    />
  );
}

export default memo(AthleteTableRowCheckboxContainer);
